<div [class]="classes" role="tablist" aria-multiselectable="true">
  <ng-content></ng-content>
</div>